import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	EventEmitter,
	Output,
} from '@angular/core';
import { MediaService } from '../../../services/media.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgImageSliderModule } from 'ng-image-slider';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { QuillViewComponent } from '../../../../../shared/components/quill-view/quill-view.component';
import { NgIf, NgClass } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ImageSliderDialogComponent } from '../../dialogs/image-slider-dialog/image-slider-dialog.component';

@Component({
	selector: 'app-fundraiser-about',
	templateUrl: './fundraiser-about.component.html',
	standalone: true,
	imports: [
		NgIf,
		QuillViewComponent,
		NgClass,
		ExtendedModule,
		NgImageSliderModule,
		FlexModule,
		PageLoaderComponent,
	],
})
export class FundraiserAboutComponent implements OnInit, OnChanges {
	@Input() currentFundraiser!: any;
	@Input() isChildFundraiser!: boolean;
	@Input() fundraiserDescriptionData!: any;
	@Input() isLoading!: boolean;
	parentFundraiserAboutcontent: string = '';
	fundraiserMediaList: {}[] = [];
	mediaLength: number = 0;
	getParentFundraiserDescription: any;
	getChildFundraiserDescription: any;
	locale: string = '';
	localeSuffix: string | any = '';
	@Output() readMoreClicked = new EventEmitter<boolean>();
	constructor(
		public _mediaService: MediaService,
		public _accountService: AccountService,
		public _fundraiserService: FundraiserService,
		private dialog: MatDialog
	) {
		this.locale = this._accountService.getLocaleId();
		this.localeSuffix = this._fundraiserService.getLocaleSuffix(this.locale);
	}
	ngOnChanges(changes: SimpleChanges): void {
		// console.log("fundraiser description",this.fundraiserDescriptionData);
		if (this.currentFundraiser && this.currentFundraiser?.image_list) {
			// console.log(this.currentFundraiser?.image_list);
			this.fundraiserMediaList = this._mediaService.getSliderMediaList(
				this.currentFundraiser?.image_list
			);
			if (
				this.fundraiserMediaList &&
				this.fundraiserMediaList != undefined &&
				this.fundraiserMediaList != null
			) {
				this.mediaLength = this.fundraiserMediaList?.length;
			}
		}

		if (this.isChildFundraiser === true) {
			let translationContent =
				this.fundraiserDescriptionData?.parent?.translations?.[
					'content_' + this.locale
				];
			this.parentFundraiserAboutcontent =
				translationContent || this.fundraiserDescriptionData?.parent?.content;
			this.parentFundraiserAboutcontent =
				this.parentFundraiserAboutcontent?.trim();
		}
	}

	openCustomDialog(clickedImage: any, imageList: any): void {
		this.dialog.open(ImageSliderDialogComponent, {
			data: {
				images: imageList,
				clickedImage,
			},
			maxWidth: '95vw',
			width: '100%',
		});
	}
	onReadMoreClick() {
		this.readMoreClicked.emit(false);
	}
	ngOnInit(): void {}
}
